import { Controller } from "@hotwired/stimulus"
import { put } from "@rails/request.js";

export default class extends Controller {
  static values = {
    urlEndpoint: String,
  }

  async execute(e){
    const updateValue = e.target.value;
    const updateName = e.target.name;

    const body = {};
    const [parent, child] = updateName.split(/[\[\]]/).filter(Boolean);
    body[parent] = { [child]: updateValue };

    console.log(body);

    await put(this.urlEndpointValue, {
      responseKind: "turbo-stream",
      body,
    });
  }
}
